import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const STORAGE_KEY = 'coldchain-ui-preset';

export const UI_PRESETS = [
  {
    id: 'corporate-clean',
    name: 'Corporate Clean',
    description: 'Balanced enterprise SaaS with structured cards and calm data surfaces.',
    accent: 'from-blue-500 to-cyan-400',
  },
  {
    id: 'protocol-7',
    name: 'Polaris Enterprise',
    description: 'A fully different enterprise compliance cockpit with command layouts, tactical density, and richer data workflows.',
    accent: 'from-cyan-400 to-blue-600',
  },
];

const UIPresetContext = createContext(null);

const getInitialPreset = () => {
  if (typeof window === 'undefined') {
    return UI_PRESETS[0].id;
  }
  return localStorage.getItem(STORAGE_KEY) || UI_PRESETS[0].id;
};

export const UIPresetProvider = ({ children }) => {
  const [uiPreset, setUIPresetState] = useState(getInitialPreset);

  useEffect(() => {
    document.documentElement.dataset.uiPreset = uiPreset;
    localStorage.setItem(STORAGE_KEY, uiPreset);
  }, [uiPreset]);

  const value = useMemo(
    () => ({
      uiPreset,
      setUIPreset: setUIPresetState,
      presets: UI_PRESETS,
    }),
    [uiPreset],
  );

  return <UIPresetContext.Provider value={value}>{children}</UIPresetContext.Provider>;
};

export const useUIPreset = () => {
  const context = useContext(UIPresetContext);
  if (!context) {
    throw new Error('useUIPreset must be used within UIPresetProvider');
  }
  return context;
};